export { default } from './QuickSearch';
